import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from '../helpers'

export const GET_LOCATIONS_BY_ZIP_RADIUS_FAILURE = 'showrooms/get locations by zip radius failed'
export const getLocationsByZipRadiusFailure = fsaError(GET_LOCATIONS_BY_ZIP_RADIUS_FAILURE)

export const GET_LOCATIONS_BY_ZIP_RADIUS = 'showrooms/get locations by zip radius'
/**
 * @param {Object} payload
 * @param {String} payload.zip The zip code input
 * @param {String} payload.distance The distance selected
 */
export const getLocationsByZipRadius = fsaPayloadByKeys(GET_LOCATIONS_BY_ZIP_RADIUS, [
  'zip',
  'distance',
])

export const GET_LOCATIONS_BY_ZIP_RADIUS_PENDING = 'showrooms/get locations by zip radius pending'
export const getLocationsByZipRadiusPending = fsa(GET_LOCATIONS_BY_ZIP_RADIUS_PENDING)

export const GET_LOCATIONS_BY_ZIP_RADIUS_SUCCESS =
  'showrooms/get locations by zip radius successful'
export const getLocationsByZipRadiusSuccess = fsaPayload(GET_LOCATIONS_BY_ZIP_RADIUS_SUCCESS)

export const TOGGLE_LOCATIONS_TBT_NORDSTROM_FILTER =
  'showrooms/toggle locations tbt and nordstrom filter'
export const toggleLocationsTbtNordstromFilter = fsa(TOGGLE_LOCATIONS_TBT_NORDSTROM_FILTER)

export const TOGGLE_LOCATIONS_DAVIDS_BRIDAL_FILTER =
  'showrooms/toggle locations davids bridal filter'
export const toggleLocationsDavidsBridalFilter = fsa(TOGGLE_LOCATIONS_DAVIDS_BRIDAL_FILTER)
